import React from 'react';
import '../Cards.css';
import CardItem from '../CardItem';

function Astar() {
  window.scrollTo(0, 0)
  return (

    <div id='about' className='cards'>
      <h1>ASTAR Paid Research Internship </h1>
      <h3 className="cards-description">Completed a research internship at A*STAR where I used the Kinetic-Monte Carlo simulation to model polycrystalline depositions. I analysed results by plotting crystal orientations using Matlab and compared results to ones from the SPPARKS model to gauge the accuracy of our model. I wrote a bash script to change input parameters, complete a simulation run and then process results.
      </h3>

      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>

            <CardItem
              src='images/astar1.jpg'
              text='Model used to plot simulation results in 3D'
              label='Written in Matlab'
            />
            <CardItem
              src='images/astar.jpg'
              label="ASTAR"
              text='Government funded research institute'
            />


          </ul>

        </div>
      </div>
    </div>


  )
}

export default Astar
